"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Links = exports.browserCssMetaList = exports.TAG_CSS_CHUNK_ID = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const atom_1 = require("../atom");
const react_1 = require("@remix-run/react");
const jotai_1 = require("jotai");
const react_2 = require("react");
const react_router_dom_1 = require("react-router-dom");
exports.TAG_CSS_CHUNK_ID = 'data-css-chunk-id';
exports.browserCssMetaList = [];
/**
 * @see https://github.com/remix-run/remix/blob/%40remix-run/react%401.17.1/packages/remix-react/components.tsx#L384
 */
const CssInlineLinks = () => {
    const { matches } = (0, react_2.useContext)(react_router_dom_1.UNSAFE_DataRouterStateContext);
    const { manifest } = (0, react_2.useContext)(react_1.UNSAFE_RemixContext);
    const serverContext = (0, jotai_1.useAtomValue)(atom_1.$ServerContext);
    const [hydrated, setHydrated] = (0, react_2.useState)(false);
    (0, react_2.useEffect)(() => {
        setHydrated(true);
    }, []);
    const cssMetaList = (0, react_2.useMemo)(() => {
        const cssImports = matches.flatMap((match) => manifest.routes[match.route.id].cssImports);
        if (__BUILD_TARGET__ === 'client') {
            return exports.browserCssMetaList;
        }
        return cssImports.map((id) => ({
            id,
            content: serverContext.css[id],
        }));
    }, []);
    const cssCDNList = (0, react_2.useMemo)(() => {
        const cssCDNImports = matches.flatMap((match) => manifest.routes[match.route.id].cssImports);
        const cssInlineList = cssMetaList.map((m) => m.id);
        return cssCDNImports.filter((i) => !cssInlineList.includes(i));
    }, [matches, cssMetaList]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [cssMetaList.map((a) => ((0, jsx_runtime_1.jsx)("style", { ...{ [exports.TAG_CSS_CHUNK_ID]: a.id }, dangerouslySetInnerHTML: { __html: a.content }, suppressHydrationWarning: true }, a.id))), cssCDNList.map((a) => ((0, jsx_runtime_1.jsx)("link", { rel: "stylesheet", href: a }, a)))] }));
};
const Links = () => {
    const { enableSSRStyleInline } = (0, jotai_1.useAtomValue)(atom_1.$RenderConfig);
    if (!enableSSRStyleInline) {
        return (0, jsx_runtime_1.jsx)(react_1.Links, {});
    }
    return (0, jsx_runtime_1.jsx)(CssInlineLinks, {});
};
exports.Links = Links;
